module.exports = __webpack_public_path__ + "assets/images/planning-laptop-phone.f191b6d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/GeneralPlanning/assets/planning-laptop-phone.png
// module id = 1308
// module chunks = 0